// File size validation utilities for media files

/**
 * Validates file size based on the maximum allowed size in MB
 * @param file - The file to validate (can be File object, base64 string, or file path)
 * @param maxSizeInMB - Maximum allowed size in megabytes
 * @returns true if valid, or error message string if invalid
 */
const validateFileSize = (file: any, maxSizeInMB: number) => {
    if (!file) return true; // Allow empty files (required validation handles this)
    
    let fileSize: number;
    
    // Handle base64 encoded files (from CustomImageInput)
    if (typeof file === 'string' && file.startsWith('data:')) {
      // Calculate size from base64 string
      const base64Length = file.split(',')[1]?.length || 0;
      fileSize = (base64Length * 3) / 4; // Convert base64 to approximate byte size
    } 
    // Handle File objects (from FileUploader)
    else if (file instanceof File) {
      fileSize = file.size;
    }
    // Handle file paths/strings (existing files)
    else if (typeof file === 'string') {
      return true; // Skip validation for existing file paths
    }
    else {
      return true; // Skip validation for unknown file types
    }
    
    const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
    return fileSize <= maxSizeInBytes || `File size must be less than ${maxSizeInMB}MB`;
  };
  
/**
 * Validates image file size (max 2MB)
 */
export const validateImageSize = (file: any) => validateFileSize(file, 2);

/**
 * Validates video file size (max 10MB)
 */
export const validateVideoSize = (file: any) => validateFileSize(file, 10);

/**
 * Validates document file size (max 5MB)
 */
export const validateDocumentSize = (file: any) => validateFileSize(file, 5);